import clsx from 'clsx';
import React from 'react';

const Badge = ({ children, className, appearance = 'info', ...props }) => (
  <div
    className={clsx(
      className,
      'first-letter:uppercase inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80',
      {
        'bg-green-300 text-white': appearance === 'success',
        'bg-orange-500 text-white': appearance === 'warning',
        'bg-red-500 text-white': appearance === 'error',
        'bg-gray-500 text-white': appearance === 'info',
        'bg-black text-white': appearance === 'black',
        'bg-none text-gray-500': appearance === 'outline',
      },
    )}
    {...props}
  >
    {children}
  </div>
);

export default Badge;
